module.exports = __webpack_public_path__ + "74d8dd37abd74aa40ec98b5ac76863c6.svg";